import { render } from "./VesselCapacity.vue?vue&type=template&id=1f56500a&scoped=true"
import script from "./VesselCapacity.vue?vue&type=script&lang=js"
export * from "./VesselCapacity.vue?vue&type=script&lang=js"

import "./VesselCapacity.vue?vue&type=style&index=0&id=1f56500a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f56500a"]])

export default __exports__